"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionOverviewContainer = exports.transformProjectToCollection = exports.findValidImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const AppContext_1 = require("../AppContext");
const CollectionOverview_1 = require("./CollectionOverview");
const Thumbnail_1 = require("./Thumbnail");
const findValidImage = (data, id, thumbnails) => {
    var _a, _b, _c, _d;
    const templateThumbnail = (_b = (_a = thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails[id]) === null || _a === void 0 ? void 0 : _a.thumbnail) !== null && _b !== void 0 ? _b : (_c = Thumbnail_1.defaultThumbnail[id]) === null || _c === void 0 ? void 0 : _c.thumbnail;
    if (templateThumbnail)
        return templateThumbnail;
    const template = data.find((item) => { var _a; return !((_a = item.thumbnail) === null || _a === void 0 ? void 0 : _a.includes('blank.jpg')); });
    if (template)
        return template.thumbnail;
    return (_d = data[0]) === null || _d === void 0 ? void 0 : _d.thumbnail;
};
exports.findValidImage = findValidImage;
function transformProjectToCollection(project, onClick, thumbnails) {
    if (!Array.isArray(project === null || project === void 0 ? void 0 : project.campaigns) || !project)
        return [];
    return project.campaigns.reduce((accumulator, item) => {
        const imageUrl = (0, exports.findValidImage)(item.data, item.id, thumbnails);
        if (!imageUrl)
            return accumulator;
        return accumulator.concat({
            imageUrl,
            label: item.name,
            variant: 'full',
            onClick: () => onClick(String(item.id)),
        });
    }, []);
}
exports.transformProjectToCollection = transformProjectToCollection;
function CollectionOverviewContainer() {
    const { project, navigateTo, loadTemplates, thumbnails, } = (0, react_1.useContext)(AppContext_1.AppContext);
    const onClick = (templateId) => {
        loadTemplates === null || loadTemplates === void 0 ? void 0 : loadTemplates(templateId);
        navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo({ fragment: 'templates', id: templateId });
    };
    const collections = (0, react_1.useMemo)(() => transformProjectToCollection(project, onClick, thumbnails), [project === null || project === void 0 ? void 0 : project.campaigns]);
    return ((0, jsx_runtime_1.jsx)(CollectionOverview_1.CollectionOverview, { label: 'Search for templates', collections: collections }));
}
exports.CollectionOverviewContainer = CollectionOverviewContainer;
//# sourceMappingURL=CollectionOverviewContainer.js.map